const artikeldetail = document.querySelector(`[id^="artikel_detail_"]`)

if (artikeldetail && window.XMLHttpRequest) {
    let heftId = artikeldetail.getAttribute("data-heft-issue")
    const urlParams = new URLSearchParams(window.location.search);
    const fromParam = urlParams.get('from');

    if (document.querySelector('[id^=iww-readerbar]') !== null && (fromParam !== null && ((heftId == fromParam) || fromParam.includes("nl_")))) {
        let readerbarElement = null
        if (heftId == fromParam) {
            readerbarElement = document.getElementById('iww-readerbar')
        } else if (fromParam.includes("nl_")) {
            readerbarElement = document.getElementById('iww-readerbar-newsletter')
        }

        if (readerbarElement == null) {
            // nothing to sticky-toggle
        } else {
            // Trigger-Position: Ende der Readerbar in ihrer natürlichen (nicht-fixed) Position.
            // Twostacks ProgressBar.php entfernt "h-0 overflow-hidden", daher hat die Bar
            // hier bereits eine natürliche Höhe im Fluss.
            const readerbarBottom = readerbarElement.getBoundingClientRect().bottom + window.scrollY;

            function updateStickyState() {
                const scrollTop = window.scrollY;

                // Sticky, sobald wir hinter der ursprünglichen Readerbar-Position sind.
                // Die Reader-Bar bleibt danach sichtbar und wird nicht mehr am Artikelende ausgeblendet.
                const isPastTrigger = scrollTop > readerbarBottom;

                if (isPastTrigger) {
                    readerbarElement.setAttribute('aria-hidden', 'true');
                } else {
                    readerbarElement.setAttribute('aria-hidden', 'false');
                }
            }

            // Einmal onload ausführen um progress auch schon vor dem ersten scrollen zu haben
            updateStickyState();

            window.addEventListener('scroll', updateStickyState);
        }
    }
}
